import React from 'react';
import UiKit from '../../../uikit';

const SearchInput = props => {
    let searchTimeout = null;

    const onChange = value => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            props.onSearch(value);
        }, 200)
    }

    return (
        <div className="simprakit-dropdown-list-container-search-input">
            <UiKit.Textfield
                value       = { props.value }
                onChange    = { value => onChange(value) }
                placeholder = { "Search.." }
                size        = "sml"
                full
            />
        </div>
    )
}

export default SearchInput;